





























import { Component, Vue, Watch } from 'vue-property-decorator';
@Component({})
export default class ProjectSubscription extends Vue {
  public redirect() {
    window.location.href =
      'https://www.wolterskluwer.com/en/know/jbi-resources?utm_source=email_marketing&utm_medi[…]m=email&utm_campaign=health_hlrp_pr_ovid_4-v821_jbi_202407';
  }
}
